module.exports = require("core-js/library/fn/object/get-own-property-symbols");